<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-card
      class="ma-0"
      width="100%"
      flat
    >
      <v-app-bar
        flat
        class="my-0 mb-2 py-1 px-4"
        dense
        height="30"
      >
        <v-toolbar-title> {{ $t('bank') }} / {{ $t('cash') }}</v-toolbar-title>
        <!--        <v-radio-group-->
        <!--          v-model="type"-->
        <!--          class="mt-6"-->
        <!--          row-->
        <!--        >-->
        <!--          <v-radio-->
        <!--            :label="$t('bank')"-->
        <!--            value="bank"-->
        <!--            :disabled="(id || formType ? true : false)"-->
        <!--          />-->
        <!--          <v-radio-->
        <!--            :label="$t('cash')"-->
        <!--            value="cash"-->
        <!--            :disabled="(id || formType ? true : false)"-->
        <!--          />-->
        <!--        </v-radio-group>-->
        <v-checkbox
          v-model="status"
          class="mt-6 mx-4"
          :label="$t('status') + '  :  ' + (status ? $t('active') : $t('deactive'))"
          value="active"
        />
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="id"
              v-bind="attrs"
              icon
              small
              class="float-left"
              v-on="on"
              @click="goTo(type)"
            >
              <v-icon
                color="teal"
                style="font-size: 22px"
              >
                mdi-plus-box-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t(type) }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!formType"
              v-bind="attrs"
              icon
              small
              v-on="on"
              @click="goTo(type + 'List')"
            >
              <v-icon
                color="primary"
                style="font-size: 22px"
              >
                mdi-format-list-numbered
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t(type + 'List') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="!formType"
              v-bind="attrs"
              icon
              small
              v-on="on"
              @click="$router.go(-1)"
            >
              <v-icon
                color="primary"
                style="font-size: 22px"
              >
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('back') }}</span>
        </v-tooltip>
      </v-app-bar>
      <v-progress-linear
        :active="!render"
        :indeterminate="!render"
        absolute
        bottom
        style="top: -4px"
        color="primary"
      />
      <v-container
        v-if="render"
        fluid
      >
        <v-row>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-text-field
              v-model="name"
              :label="$t('name')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            v-if="type == 'bank'"
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-text-field
              v-model="number"
              :label="$t('number') + ' ' + $t('account')"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
          >
            <autocomplete
              ref="refCurrency"
              v-model="currency"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('currency')"
              type="currency"
              :init="defaultCurrency"
              :value="currency"
              :disabled="(id && !$store.state.isMainYear ? true : false)"
              @change="changeCurrency"
            />
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
          >
            <money
              v-model="currency_amount"
              :label="$t('currency-rate')"
              :rules="[v => !!v || $t('is-required')]"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              :disabled="(id && !$store.state.isMainYear ? true : false)"
              value-when-is-empty=""
              :options="currencyOptions"
            />
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
            class="mb-1"
          >
            <money
              v-model="initial_price"
              :label="$t('initialPrice')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              :disabled="!$store.state.isMainYear"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <tag
              v-model="tag"
              :solo="false"
              :input="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <autocomplete
              v-model="given"
              :title="$t('given')"
              type="given"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <description
              v-model="content"
              :outlined="true"
              :value="content"
              type="sell"
            />
          </v-col>
        </v-row>
        <v-row v-if="type == 'cash'">
          <v-col cols="3">
            <v-btn
              small
              outlined
              color="primary"
              @click="addPOS"
            >
              <v-icon
                color="primary"
                style="font-size: 22px"
              >
                mdi-point-of-sale
              </v-icon>
              {{$t('newPOS')}}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="type == 'cash'">
          <div
            v-for="(item, i) in posItems"
            :key="i"
            class="d-flex"
            style="width: 100%"
          >
            <v-col
              cols="12"
              md="2"
            >
              <v-select
                v-model="item.type"
                :label="$t('posType')"
                :items="posTypeItems"
                height="30"
                dense
                outlined
                item-value="value"
                item-text="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="mb-0  "
            >
              <v-text-field
                v-model="item.name"
                :label="$t('posName')"
                height="20"
                dense
                outlined
                class="mb-1 dense"
                clearable
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="mb-0  "
            >
              <v-text-field
                v-model="item.terminal_number"
                :label="$t('terminalNumber')"
                height="20"
                dense
                outlined
                class="mb-1 dense"
                clearable
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="mb-0  "
            >
              <v-text-field
                v-model="item.username"
                :label="$t('username')"
                height="20"
                dense
                outlined
                class="mb-1 dense"
                clearable
              />
            </v-col>
            <v-col
              cols="12"
              md="2"
              class="mb-0  "
            >
              <v-text-field
                v-model="item.password"
                :label="$t('password')"
                height="20"
                dense
                outlined
                class="mb-1 dense"
                clearable
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              class=""
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="pink"
                    icon
                    small
                    v-bind="attrs"
                    class="ms-2"
                    v-on="on"
                    @click="removePos(item)"
                  >
                    <v-icon
                      color="pink"
                      style="font-size: 22px"
                    >
                      mdi-close-box
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('remove') }}</span>
              </v-tooltip>
            </v-col>
          </div>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              v-if="!formType"
              color="grey"
              outlined
              class="float-left"
              @click="goTo( type + 'List' )"
            >
              {{ $t(type + 'List') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <snakbara
        :text="snakbarText"
        :active="snakbar"
        :color="snakbarColor"
      />
    </v-card>
  </v-form>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Description from '../../components/general/description/Description'
  export default {
    name: 'Product',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      // aicomplete,
      Description,
      Tag: () => import('../../components/general/Tag/tag'),
    },
    mixins: [General],
    props: ['formType'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      currencyOptions: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 10,
      },
      posStatus: false,
      render: false,
      isLoading: false,
      alert: false,
      given: null,
      tag: null,
      content: null,
      valid: null,
      posItems: [],
      posTypeItems: null,
      message: null,
      alertType: null,
      name: null,
      id: null,
      currency: null,
      currency_amount: null,
      status: 'active',
      number: null,
      type: 'bank',
      initial_price: null,
      loading: false,
    }),
    watch: {
      defaultCurrency () {
        if (this.defaultCurrency) {
          this.$refs.refCurrency.setModel(this.defaultCurrency)
          this.currency_amount = this.defaultCurrency.amount
        }
      },
      currency (val, old) {
        if (val) {
          this.currency_amount = val.amount
          this.options.suffix = val.symbol
        } else {
          this.options.suffix = ' '
          this.currency_amount = null
        }
      },
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
        this.defaultCurrency = this.getDefault('defaultCurrency')
      }
    },
    mounted () {
      if (this.$route.name !== 'bank') {
        this.type = 'cash'
      } else {
        this.type = 'bank'
      }
      if (this.formType) {
        this.type = this.formType
      }
      this.posTypeItems = [
        {
          value: 'samanKish',
          text: this.$t('samanKish'),
        },
      ]
    },
    methods: {
      removePos (item) {
        var i = this.posItems.indexOf(item)
        this.posItems.splice(i, 1)
      },
      addPOS () {
        if (!this.posItems) {
          this.posItems = []
        }
        if (this.posItems.length === 0) {
          var item = {
            name: null,
            type: null,
            terminal_number: null,
            username: null,
            password: null,
          }
          this.posItems.push(item)
        }
      },
      changeCurrency () {
        this.bankRemain = 0
        this.currency_amount = this.currency.amount
        this.options = {
          locale: 'en-US',
          prefix: '',
          suffix: this.currency.symbol,
          precision: 0,
        }
      },
      create () {
        var app = this
        app.alert = false
        app.isLoading = true
        // app.currency = app.defaultCurrency
        app.$axios.post(this.$endpoint + 'bank', app.$data)
          .then(res => {
            if (app.id) {
              app.goTo(app.type + 'List')
            } else {
              app.$emit('input', res.data.data)
              app.snakbarText = app.$t('registered')
              app.snakbarColor = 'green'
              app.snakbar = true
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
            this.clearForm()
          })
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'bank/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.type = res.type
              app.typeForm = res.type
              app.id = res.id
              app.name = res.name
              app.status = res.status
              app.given = res.given
              app.number = res.number
              app.posItems = (res.pos ? [res.pos] : null)
              app.initial_price = res.initial_price
              app.currency = res.currency
              app.currency_amount = res.currency_amount
              app.content = res.content
              if (res.tags) {
                app.tag = res.tags
              }
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'bank/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.$emit('close', app.$route)
            app.goTo(app.type + 'List')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      clearForm () {
        this.tag = null
        this.content = null
        this.name = null
        this.snakbar = false
        this.id = null
        // this.currency_amount = null
        this.status = 'active'
        this.number = null
        this.initial_price = null
      },
    },
  }
</script>

<style scoped>

</style>
